import React from 'react';
import FormattedNumber from 'components/FormattedNumber';

interface ReadOnlyCurrencyProps {
  label: string;
  value: number;
  testId: string;
}

// An untouched/zero computed value shows "$---", not "$0.00" — matching the
// reviewed frame's empty state for Total Fixed Cost, Yield Revenue, and
// Projected Net Revenue.
export const ReadOnlyCurrency: React.FC<ReadOnlyCurrencyProps> = ({
  label,
  value,
  testId
}) => (
  <div className="flex flex-col">
    <span className="text-neutral-60 mb-2px text-sm leading-4">{label}</span>
    <div
      className="flex items-center h-full text-base font-regular text-neutral-1000"
      data-testid={testId}
    >
      {value ? (
        <FormattedNumber unit="usCurrency" roundedTo={2}>
          {value}
        </FormattedNumber>
      ) : (
        '$ ---'
      )}
    </div>
  </div>
);

interface GroupedCurrencyPairProps {
  label: string;
  first: React.ReactNode;
  second: React.ReactNode;
}

// `.plan-grouped-currency-pair` (style.css) reproduces the antd
// Space.Compact joined-input look, since the ui-kit's bundled antd v4
// instance doesn't share context with this app's antd v5.
export const GroupedCurrencyPair: React.FC<GroupedCurrencyPairProps> = ({
  label,
  first,
  second
}) => (
  <div className="flex flex-col">
    <span className="text-neutral-60 text-sm leading-4">{label}</span>
    <div className="plan-grouped-currency-pair">
      <div>{first}</div>
      <div>{second}</div>
    </div>
  </div>
);
